/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export * from './config/utils';
export * from './configs';
export * from './error';
export * from './mockApolloClient/mockApollo';
export * from './constants';
export * from './errorMessages';
export * from './fetch';
export * from './utils';
export * from './api';
export * from './limits';
export * from './types';
export * from './model';
export * from './cache';
export * from './headers';

export const PLATFORM_NAME_CONFIG_PATH = 'app.title';
